
















import { Subscription, Event, EventJson } from 'inscreva-sse-models';
import { Component, Vue } from 'vue-property-decorator';

import Loading from '@/components/base/Loading.vue';
import TalksInfo from '@/components/templates/TalksInfo.vue';
import toast from '@/components/toast';
import { ToastType } from '@/components/toast/tost-type.enum';

import EmptyEventMessage from '../components/EmptyEventMessage.vue';
import { sessionStore } from '../store/session';
import { subscriptionStore } from '../store/subscription';

@Component({
  components: {
    Loading,
    TalksInfo,
    EmptyEventMessage,
  },
})
export default class InfosPage extends Vue {
  private isLoading: boolean = null;

  private subscriptions: Array<Subscription> = [];

  async created() {
    await this.fetch();
  }

  async fetch() {
    try {
      this.isLoading = true;
      this.subscriptions = await subscriptionStore.list();
    } catch (err) {
      toast('Erro ao carregar dados', ToastType.ERROR);
    }
    this.isLoading = false;
  }

  get event(): Event {
    return EventJson.fromJson(sessionStore.session.event);
  }

  get template(): string {
    return this.event.steps.find(({ type }) => type === 'template')?.info.identifier;
  }

  get template_info(): string {
    return this.template && `${this.template}Info`;
  }
}
